var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTransactionForsale = function SvgIconTransactionForsale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    fillRule: "evenodd",
    d: "m12.192 2.034 3.785 3.768a4.608 4.608 0 0 1-.001 6.508l-3.659 3.658v.001a4.609 4.609 0 0 1-6.509 0l-3.775-3.776A4.628 4.628 0 0 1 .684 8.715v-.002l.2-4.168A3.845 3.845 0 0 1 4.554.893h.002l4.162-.2h.001a4.585 4.585 0 0 1 3.473 1.341Zm-.884.884a3.334 3.334 0 0 0-2.525-.976H8.78l-4.166.2h-.002a2.595 2.595 0 0 0-2.48 2.465L1.934 8.77c-.042.95.317 1.87.984 2.538l3.775 3.775a3.358 3.358 0 0 0 4.742 0l3.658-3.658a3.358 3.358 0 0 0-.002-4.742l-3.78-3.765h-.002Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    fillRule: "evenodd",
    d: "M6.917 5.46a1.458 1.458 0 1 0 0 2.918 1.458 1.458 0 0 0 0-2.917ZM4.21 6.92a2.708 2.708 0 1 1 5.417 0 2.708 2.708 0 0 1-5.417 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgIconTransactionForsale;